/**
 * Created by renjie.huang on 2017/11/6.
 */

var actions = {
	login: {
		getUserInfo: {
			action: 'GetUserInfo',
			collection: 'DataSet',
		},
		GetUserAuthInfo: {
			action: 'GetUserAuthInfo'
		},
		loginByPassword: {
			action: 'LoginByPassword',
		},
		loginByIAMUser:{
			action:'LoginByIAMUser',
			headers: { "Content-Type": "application/json" }
		},
		checkVerificationCode: {
			action: 'CheckVerificationCode',
		},
		checkEmailCodeByEmailKey: {
			action: 'CheckEmailCodeByEmailKey'
		},
		getEmailByKey: {
			action: 'GetEmailByKey'
		},
		loginByYangcong: {
			action: 'LoginByYangcong',
		},
		loginByWechat: {
			action: 'LoginByWechat',
		},
		loginByTOTP: {
			action: 'LoginByTOTP',
		},
        checkLoginTOTP: {
			action: 'CheckLoginTOTP',
		},
		getQRCodeURL: {
			action: 'GetQRCodeURL',
		},
		getQRCodeResult: {
			action: 'GetQRCodeResult',
		},
		scanUrl: {
			action: 'scanUrl',
			collection: '',
		},
		pollingScan: {
			action: 'pollingScan',
		},
		modifyUserInfo: {
			action: 'ModifyUserInfo',
		},

		sendPhoneVerifyCode: {
			action: 'SendPhoneVerificationCode',
		},

		sendEmailVerifyCode: {
			action: 'SendEmailVerificationCode',
		},
        getQRCode: {
			action: 'GetQRCode',
		},
        checkLoginQRCode: {
			action: 'CheckLoginQRCode',
		},
        LoginBySms: {
            action: 'LoginBySms',
        },
        SendPhoneVerificationCodeV2: {
            action: 'SendPhoneVerificationCodeV2'
        },
		GetPasswordPolicyForActivateUser: {
			action: 'GetPasswordPolicyForActivateUser'
		},
		GetPasswordPolicyForResetPassword: {
			action: 'GetPasswordPolicyForResetPassword'
		}
	},
	logout: {
		action: 'LogoutToken',
	},
	register: {
		sendRegisterPhoneCode: {
			action: 'SendRegisterPhoneCode',
		},
		checkEmail: {
			action: 'CheckEmail',
		},
		checkPhone: {
			action: 'CheckPhone',
		},
		activateAccount: {
			action: 'ActivateAccount',
		},
		registerAccount: {
			action: 'RegisterAccount',
		},
		sendActivateEmail: {
			action: 'SendActivateEmail',
		},
		resetPassword: {
			action: 'ResetPassword',
		},

		getCountryCodeList: {
			action: 'GetCountryCodeList',
			collection: 'DataSet',
		},
		// sendResetPasswordEmailCode: {
		// 	action: 'SendResetPasswordEmailCode',
		// },
		SendResetPasswordEmail: {
			action: 'SendResetPasswordEmail'
		},
		getIndustryTypeList: {
			action: 'GetIndustryTypeList',
			collection: 'IndustryTypeList',
		},
		RegisterGeekVerification:{
			action:'RegisterGeekVerification',
		},
	},
	retrieve: {
		GetUserPhoneByEmail: {
			action: 'GetUserPhoneByEmail',
		},
		CheckPhoneCodeByEmail: {
			action: 'CheckPhoneCodeByEmail',
		},
		SendPhoneCodeByEmail: {
			action: 'SendPhoneCodeByEmail',
		},
		SendPhoneCodeByEmailKey: {
			action: 'SendPhoneCodeByEmailKey'
		},
		CheckPhoneCodeByEmailKey: {
			action: 'CheckPhoneCodeByEmailKey'
		},
		ResetPassword: {
			action: 'ResetPassword',
		},
		GetUserPhoneByEmailKey: {
			action: 'GetUserPhoneByEmailKey'
		}
	},
	changePwd: {
		ModifyPasswordByOldPassword: {
			action: 'ModifyPasswordByOldPassword',
		},
	},
	activeSub: {
		ActivateSubaccount: {
			action: 'ActivateSubaccount',
		},
		ActivateLoginProfile:{
			action:'ActivateLoginProfile'
		}
    },
	ssoinfo: {
		GetUserSSOInfo: {
			action: 'GetUserSSOInfo',
			headers: { "Content-Type": "application/json" }
		}
	},
  subaccountAuth:{
    bindTOTPByPassword:{
      action: 'BindTOTPByPassword',
    }
  },
  campus: {
	RegisterUniversityAccount: {
		action: 'RegisterUniversityAccount'
	},
	CreateUniversityRegistrationInfo: {
		action: 'CreateUniversityRegistrationInfo'
	},
	CheckUniversityRegistrationLocationInfo: {
		action: 'CheckRegistrationSubInstitutionInfo'
	},
	CheckUniversityVerifyInfo: {
		action: 'CheckUniversityVerifyInfo'
	},
	createRealNameSession: {
        action: 'CreateRealNameSession',
    },
    checkRealNameSession: {
        action: 'CheckRealNameSession',
    },
	GetDataFromSupplier: {
		action: 'ListSubInstitutions'
	}
  },
  oauth: {
    // 创建 OAuth 授权链接
    CreateOAuthURL: {
        action: 'CreateOAuthURL'
    },
    // 使用 OAuth 授权码登录账号
    LoginByOAuth: {
        action: 'LoginByOAuth'
    },
    // OAuth 授权成功后补充用户手机号
    BindPhoneByOAuth: {
        action: 'BindPhoneByOAuth'
    }
  }
}
module.exports = actions



// WEBPACK FOOTER //
// ./src/common/action.js